// 整体项目参数配置
module.exports = {

  title: '筋斗云赛事发布系统',

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: true,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: true
}



// WEBPACK FOOTER //
// ./src/settings.js